export { createErrorDescriptor } from 'common/error-handler';
export type { ErrorDescriptor } from 'common/error-handler';
